// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__TaxReportingCarousel from "./TaxReportingCarousel.js";
import * as Buhta_landing__TaxReportingIntro from "./TaxReportingIntro.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function TaxReporting(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Buhta_landing__TaxReportingIntro.make, {}),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h4", {
            children: "Все взаимодействия с налоговой через Бухту. Докажем каждую цифру.",
            className: "h4 lg:h3 text-center lg:flex lg:m-auto lg:w-200 text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "Если раньше ваша отчетность складывалась из множества разрозненных документов и собрать ее было сложной  непонятной задачей, то с Бухтой вы просто занимаетесь своим делом, а система сама все учитывает и аккуратно укладывает  в отчет. В случае налоговой проверки вы сможете открыть Бухту и показать почему иименно вы указали ту или эту цифру в отчете.",
            className: "paragraph-large lg:h-light text-center lg:flex lg:mx-auto mt-2 lg:w-200 text-black-landing"
          }),
          JsxRuntime.jsx("img", {
            className: Cn.fromList({
              hd: "lg:flex lg:m-auto mt-10 lg:mt-20 lg:w-252",
              tl: /* [] */ 0
            }),
            alt: "tax report",
            src: StaticAsset.src(deviceType === "mobile" ? "/static/images/tax-report.png" : "/static/images/tax-report-desktop.png")
          }),
          JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
            classes: {
              hd: "flex m-auto mt-10 lg:mt-20",
              tl: /* [] */ 0
            },
            label: Buhta_landing__I18n.trans(intl, "start_using"),
            onClick: (function (param) {
              Buhta_landing__EventHandlers.scrollToFooter(deviceType);
            })
          }),
          JsxRuntime.jsx("p", {
            children: "Уже пользуются 125 предпринимателей",
            className: "paragraph-small text-center text-gray-landing mt-4"
          })
        ],
        className: "py-10 lg:py-40 px-6 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/guard-circled.svg")
          }),
          JsxRuntime.jsx("h3", {
            children: "100% гарантия на наши услуги",
            className: "h4 lg:h3 text-center text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "Гарантируем корректную отправку отчетности в налоговую. В случае если отчетность по какой-то причине не будет принята, мы свяжемся с вами и сообщим об этом для принятия решения по дальнейшим действиям.",
            className: "paragraph lg:h-light text-center text-gray-landing lg:w-180 mt-2"
          })
        ],
        className: "flex m-auto lg:w-252 pt-8 lg:pt-18 pb-10 lg:pb-20 flex-col items-center lg:rounded-sm px-6 sm:px-48 lg:px-0 bg-bg"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h4", {
            children: "Как это выглядит в Бухте",
            className: "h4 lg:h3 text-center text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "Бухта собирает все данные по кассе, актам выполненных работ, накладным на отпуск товаров на сторону, счетам фактурам, банку и на основе этих данных формирует отчетность. После подтверждения правильности заполнения формы клиентом, отчетность отправляется в налоговую и ответ от налоговой о ее принятии сохраняется у вас в кабинете.",
            className: "paragraph-large lg:h-light text-center lg:flex lg:mx-auto mt-2 lg:w-200 text-black-landing"
          }),
          JsxRuntime.jsx(Buhta_landing__TaxReportingCarousel.make, {})
        ],
        className: "py-10 lg:py-40 px-6 sm:px-48 lg:px-0"
      })
    ]
  });
}

const make = TaxReporting;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
